var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "hero is-fullheight" }, [
    _c("div", { staticClass: "hero-body" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column is-one-third is-offset-one-third" },
            [
              _c("div", { staticClass: "card", attrs: { id: "login-card" } }, [
                _c(
                  "div",
                  { staticClass: "card-content has-text-centered" },
                  [
                    _c("h1", { staticClass: "title is-1 has-text-info" }, [
                      _vm._v(" Forgot Password "),
                    ]),
                    _c("h2", { staticClass: "subtitle is-6 has-text-grey" }, [
                      _vm._v(
                        " Please enter your email address or username. You will receive a link to create a new password via email. "
                      ),
                    ]),
                    _c("ValidationObserver", {
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ invalid }) {
                            return [
                              _c(
                                "form",
                                {
                                  attrs: { id: "login" },
                                  on: {
                                    submit: function ($event) {
                                      $event.preventDefault()
                                      return _vm.sendMail()
                                    },
                                  },
                                },
                                [
                                  _c("ValidationProvider", {
                                    attrs: {
                                      slim: "",
                                      rules: "required",
                                      name: "Password",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors, valid }) {
                                            return [
                                              _c(
                                                "b-field",
                                                {
                                                  attrs: {
                                                    type: {
                                                      "is-danger": errors[0],
                                                      "is-success": valid,
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("b-input", {
                                                    ref: "email",
                                                    attrs: {
                                                      rounded: "",
                                                      name: "username",
                                                      placeholder:
                                                        "Username or E-mail",
                                                      type: "text",
                                                      icon: "user",
                                                    },
                                                    model: {
                                                      value: _vm.creditential,
                                                      callback: function ($$v) {
                                                        _vm.creditential = $$v
                                                      },
                                                      expression:
                                                        "creditential",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        type: "is-info",
                                        rounded: "",
                                        loading: _vm.isLoading,
                                        disabled: invalid,
                                        expanded: "",
                                        "native-type": "submit",
                                      },
                                    },
                                    [_vm._v(" Send Request ")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }